import React, { FC, useCallback, useMemo } from 'react';
import i18next from 'i18next';
import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useStyles } from '../../styles';
import { Language } from '../../../../models/Language';

interface Props {
    description: string;
    languages?: Language[];
    tags?: string;
}

const EventDetails: FC<Props> = ({ description, languages, tags }) => {
    const classes = useStyles();

    const getTags = useCallback(() => {
        try {
            return JSON.parse(tags || '');
        } catch (error) {
            return [];
        }
    }, [tags]);

    const parsedTagsArray: string[] = useMemo(() => getTags(), [getTags]);

    return (
        <div className={classes.eventDetails}>
            <h5 className={classes.sectionTitle}>{i18next.t('EventPageComponentLiveEventDescription')}</h5>
            <p className={classes.eventDescription}>{description}</p>

            <h5 className={classes.sectionTitle}>{i18next.t('EventPageComponentLanguage')}</h5>
            <Grid container direction="row" wrap="wrap">
                {languages?.map(language => (
                    <div key={language.lang_ide} className={classes.language}>
                        <img className={classes.languageImage} src={language.lang_image} alt="" />
                        &nbsp; {language.lang_description}
                    </div>
                ))}
            </Grid>

            {parsedTagsArray.length > 0 && (
                <>
                    <h5 className={classes.sectionTitle}>{i18next.t('EventPageComponentRelatedTags')}</h5>
                    {parsedTagsArray.map((tag, index) => (
                        <Link key={index} to={`/search/${tag}`}>
                            <div className={classes.tag}># {tag.replace(/[^a-zA-Z ]/g, '')}</div>
                        </Link>
                    ))}
                </>
            )}
        </div>
    );
};

export default EventDetails;
